// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-position[data-v-655270ec]{position:fixed;bottom:32Px;right:calc(50% - 672Px)}.fn-min-height[data-v-655270ec]{min-height:100vh}@media screen and (max-width:1242px){.fixed-position[data-v-655270ec]{right:32Px}}", ""]);
// Exports
module.exports = exports;
